import moment from "moment";
import { ISelection } from "src/constants/interfaces/bet";

export const formatBookingTicketSelections = (selections: ISelection[]) =>
  selections.map(selection => {
    const { game, market, event } = selection;

    const eventViewType = [event.type, event.base].join(' ')

    return {
      gameId: game.id, 
      price: event.price,
      isLive: game.is_live,
      marketName: market.name,
      eventType: eventViewType,
      selectionName: event.name,
      team1_name: game.team1_name,
      team2_name: game.team2_name,
      title: `${game.team1_name} - ${game.team2_name}`,
      startTime: moment((game.start_ts || 0) * 1000).format("DD-MM-YYYY HH:mm"),
    };
  });
